export default {
    name: 'ActivitySkeletonLoader',
    props: {
        count: {
            type: Number,
            required: false,
            default: 3
        }
    }
};
